import { Badge } from '@/components/ui';
import {
  RESULT_FLAG_LABEL,
  REVIEW_LABEL,
  type LabOrder,
} from '@/features/orders/types';
import styles from '@/pages/queue/queue.module.css';

/** Tests with their results (value, unit, range, flag, note) and review state. */
export function LabResultsList({ order }: { order: LabOrder }) {
  return (
    <dl className={styles.rows}>
      {order.tests.map((t) => (
        <div key={t.id} style={{ display: 'contents' }}>
          <dt>{t.testName}</dt>
          <dd>
            {t.result ? (
              <>
                <strong>
                  {t.result.value}
                  {t.result.unit ? ` ${t.result.unit}` : ''}
                </strong>
                {t.result.referenceRange && (
                  <span className={styles.sub}>
                    {' '}
                    (range {t.result.referenceRange})
                  </span>
                )}{' '}
                {t.result.flag && t.result.flag !== 'normal' && (
                  <Badge
                    tone={t.result.flag === 'critical' ? 'danger' : 'warning'}
                  >
                    {RESULT_FLAG_LABEL[t.result.flag]}
                  </Badge>
                )}
                {t.result.note && (
                  <span className={styles.sub}> · {t.result.note}</span>
                )}{' '}
                {t.review && (
                  <Badge
                    tone={
                      t.review === 'released'
                        ? 'success'
                        : t.review === 'held'
                          ? 'danger'
                          : 'info'
                    }
                  >
                    {REVIEW_LABEL[t.review]}
                  </Badge>
                )}
                {t.doctorComment && (
                  <span className={styles.sub}> · “{t.doctorComment}”</span>
                )}
              </>
            ) : (
              <span className={styles.sub}>No result yet</span>
            )}
          </dd>
        </div>
      ))}
    </dl>
  );
}
